module.exports = __webpack_public_path__ + "static/media/Snow.0ba8b1b7.jpg";